import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GlossaryCreatePage } from '@/features/data/catalog/glossary-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau terme du glossaire (`POST /glossary/terms`, `/catalog/edit` sur le locataire). */
export const Route = createFileRoute('/$tenant/glossary/new')({ component: NewGlossaryTermRoute });

function NewGlossaryTermRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="glossary"
      crumbs={[{ label: t('nav.items.glossary') }, { label: t('glossary.newTitle') }]}
    >
      <GlossaryCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
